export default {"src":"/_next/static/media/Atrial Fibrillation.81cc1593.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};